import * as React from 'react';
import { connect } from 'react-redux';
import { Button, CardImg, Col, FormGroup, FormText, Input, Row } from "reactstrap";
import { Dispatch } from 'redux';
import { useState } from 'react';
import 'react-notifications-component/dist/theme.css';
import { useHistory } from 'react-router-dom';
import { channelAction } from '../../actions/channelAction';
import uploadFileToBlob from '../../services/Azure/azureBlob';
import { languageAction } from '../../actions/languageAction';
import { userAction } from '../../actions/userAction';
import { showAlert, Capitalize, updateAccessToken} from "../common/functions";
import { DABTextBox, DABDropDown, DABHtmlEditor, DABButton, DABBackToList, LoadingSpinnerModal } from '../../components/dab';
import parse from "html-react-parser";
import NoImage from '../../assets/images/noimage.png'

interface IChannelProps {
	dispatch: Dispatch<any>;
	channelData: any;
	callback: any;
	id: number;
	uniqueCode: any;
	languageData: any;
	userData: any;
}

class Guid {
	static newGuid() {
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
			var r = Math.random() * 16 | 0,
				v = c == 'x' ? r : (r & 0x3 | 0x8);
			return v.toString(16);
		});
	}
}

const ChannelDetail: React.SFC<IChannelProps> = ({
	dispatch, channelData, languageData, userData, callback, id, uniqueCode }) => {
	var channelsInput = {
		title: "",
		uniqueCode: "",
		isActive: false,
		descriptionHtml: "",
		keywords: "",
		languageCode: "",
		iconImage: "",
		bannerImageUrl: "",
		iconLocalPath: [] as any,
		bannerLocalPath: [] as any,
		icon: "",
		banner: "",
		publishTime: "2021-08-14T16:34:16.807Z",
		rolloverMonth: 0,
		rolloverDay: 0,
		rolloverBuffer: 0,
		channelId: -1,
		sortOrder: 0,
		rssFeedUrl: "",
		hideChannelTitleFromRssFeed: false,
		authorUserId: -1,
	}

	const history = useHistory();

	const [formSubmit, setformSubmit] = useState(false); 
	const [content, setContent] = useState(""); 
	const initialValue = [{ text: "English", value: "en", checked: false }];
	const [langList, setLangList] = useState(initialValue); 
	const [input, setInput] = useState(channelsInput);
	const [isEditIconChange, setIsEditIconChange] = useState(false);
	const [isEditBannerChange, setIsEditBannerChange] = useState(false);
	const [isActive, setIsActive] = useState(false); 
	const [hideChannelTitleFromRssFeed, setHideChannelTitleFromRssFeed] = useState(false);
	const [showModal, setShowModal] = useState(false); 
	const [isDetailLoaded, setDetailLoaded] = useState(false); 
	const inputIconFile = React.useRef<HTMLInputElement>(null); 
	const inputBannerFile = React.useRef<HTMLInputElement>(null); 
	const [isErrorOnPage, setIsErrorOnPage] = useState(false); 
	const [isLangListLoaded, setIsLangListLoaded] = useState(false); 
	const [languageName, setLanguageName] = useState(""); 
	const [isPreviewPage, setIsPreviewPage] = useState(false);
	const [isDirty, setIsDirty] = useState<boolean>(false)
	const [selectedIconFileName, setSelectedIconFileName] = useState("");
	const [selectedBannerFileName, setSelectedBannerFileName] = useState("");
	const [authorList, setAuthorList] = useState([{ text: "None", value: -1 }]);
	const [isUserByRolesLoaded, setIsUserByRolesLoaded] = useState(false);

	const handleNextClick = (event) => {
		event.preventDefault();
		if (content != "") {
			if (!isPreviewPage) {
				setIsPreviewPage(true);
				callback("Review Create New");
			}
			else if (isPreviewPage) {
				handleSubmit(event);
			}
		} else {
			showAlert("Description is required", true)
		}
	}

	const handleLanguageChange = (event) => {
		langList && langList.map((data: any) => {
			if (data.value === event.target.value) {
				setLanguageName(data.text);
			}
		});
	}

	const handleChange = (evt) => {
		var newContent = evt.getData();
		setContent(newContent);
		setIsDirty(newContent !== "")
	}

	const handleLoadShowModal = (value: boolean) => {
		setShowModal(value);
	};

	const handleFileChange = (event, key) => {
		const extension = event.target.files[0].name.split('.').pop()
		if (extension === "png" || extension === "jpg" || extension === "jpeg") {
			handleFileUpload(event.target.files[0], key);
			if (!showModal) {
				setShowModal(true);
			}
			setIsDirty(true)
		} else {
			event.target.value = null;
			showAlert("Please select a valid image file", true);
		}		
	};

	const handleFileUpload = async (file, key) => {
		var reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onloadend = function (e) {
			if (key == "icon") {
				setSelectedIconFileName(file.name);
				setIsEditIconChange(true);
				setInput({
					...input,
					icon: file,
					iconLocalPath: [reader.result]
				})
			} else {
				setSelectedBannerFileName(file.name);
				setIsEditBannerChange(true);
				setInput({
					...input,
					banner: file,
					bannerLocalPath: [reader.result]
				});
			}
		}.bind(this);
	};

	const handleInputChange = (event) => {
		let name = event.target.name;
		let value = event.target.value;		

		if (name == "title") {
			var cusValue = value.toString().toLowerCase().replace(/[^a-z0-9]/gi, "-");
			setInput({
				...input,
				[name]: value,
				uniqueCode: cusValue.slice(0,20),
			});
		}
		else {
			setInput({
				...input,
				[name]: value,
			});
		}
		setIsDirty(true)
	};

	const handleSubmit = async (event) => {
		event.preventDefault();
		var inp = input;
		inp.descriptionHtml = content;
		inp.isActive = isActive;
		inp.hideChannelTitleFromRssFeed = hideChannelTitleFromRssFeed;
		(inp as any).authorUserId = (input.authorUserId === null || input.authorUserId === undefined
			|| parseInt(input.authorUserId as any) === -1) ? null : parseInt(input.authorUserId as any);
		setformSubmit(true);
		setShowModal(true);
		if (isEditIconChange) {
			inp.iconImage = await uploadFileToBlob(inp.icon,
				Guid.newGuid() + input.uniqueCode, "Image");
		}
		if (isEditBannerChange) {
			inp.bannerImageUrl = await uploadFileToBlob(inp.banner,
				Guid.newGuid() + input.uniqueCode, "Image");
		}
		dispatch(channelAction.channelSave({ channel: inp }));
		setIsErrorOnPage(false);
	};

	const handleImageClick = (type: string) => {
		if (type === "icon") {
			inputIconFile?.current?.click();
		}
		else if (type === "banner") {
			inputBannerFile?.current?.click();
		}
	};

	const handleBackClick = (event) => {
		event.preventDefault();
		if (isPreviewPage) {
			setIsPreviewPage(false);
		}
		else if (!isPreviewPage) {
			history.goBack();
		}
	}

	React.useEffect(() => {
		dispatch(languageAction.languageGetByfilter())
		dispatch(userAction.userRoleGet("Episode"))
	}, []);	

	if (langList && !isLangListLoaded) {
		if (languageData.items.length > 0) {
			var list: any[] = [];
			languageData.items.map((data) => {
				var item = { text: Capitalize(data.name), value: data.languageCode, checked: true };
				list.push(item);
			});
			setLangList(list);
			setLanguageName(langList[0].text);
			setInput({
				...input,
				languageCode: langList[0].value
			});
			setIsLangListLoaded(true);
			if ((id >= 0) || (uniqueCode && uniqueCode != '')) {
				dispatch(channelAction.channelGetDetail(id, uniqueCode));
				setShowModal(true);
			}
		}
	}

	if (channelData) {
		if (channelData.isError && !isErrorOnPage && !channelData.isSuccess) {
			if (showModal) {
				setShowModal(false);
			}					
			if (channelData.status === 'Unauthorized') {
				history.push("/401");
			} else {
				showAlert(channelData.status, true);
			}
			channelData.isError = false;
			setIsErrorOnPage(true);
		}

		if (formSubmit && channelData.isSuccess) {
			if (channelData.status) {
				if (input.channelId <= 0)
					updateAccessToken(channelData.channel.accessToken)

				window.localStorage.setItem('alertMessage', channelData.status);	
				window.location.href = "/channel";
			}
		}

		if (channelData.isSuccess && !channelData.isError) {
			if (!isDetailLoaded && channelData.channelInput && channelData.channelInput !== null) {
				setInput({
					...channelData.channelInput,
					publishTime: channelData.channelInput.publishHour.toString().padStart(2, "0") + ":"
						+ channelData.channelInput.publishMinute.toString().padStart(2, "0"),
					authorUserId: channelData.channelInput.authorUserId ?? -1,
				});
				setIsActive(channelData.channelInput.isActive);
				setHideChannelTitleFromRssFeed(channelData.channelInput.hideChannelTitleFromRssFeed ?? false);
				setContent(channelData.channelInput.descriptionHtml);
				callback(channelData.channelInput.title);
				setDetailLoaded(true);
			}
		}
		if (showModal) {
			setShowModal(false);
		}
	}

	if (userData && userData.isSuccess && !isUserByRolesLoaded) {
		if (userData.isUserByRolesLoaded && !isUserByRolesLoaded) {
			if (userData.usersByRolesData && userData.usersByRolesData.length > 0) {
				let options = userData.usersByRolesData.map(el => (
					{ text: el.name + " -  " + el.userName, value: el.userId }
				));
				options.unshift({ text: "None", value: -1 });
				setAuthorList(options);
				setIsUserByRolesLoaded(true);
			}
		}
	}

	React.useEffect(() => {
		const eventHandler = (event: BeforeUnloadEvent) => {
			var sessionExpiry = window.localStorage.getItem('SESSIONEXPIRY');
			const inSession = Date.now() < Number(sessionExpiry)
			if (!formSubmit && inSession) {
				event.preventDefault();
				event.returnValue = "";
			}
		};
		if (isDirty) { window.addEventListener("beforeunload", eventHandler) }
		return () => { window.removeEventListener("beforeunload", eventHandler) };
	}, [isDirty && !formSubmit])

	return (
		<div className="channel-detail">
			{showModal && (<LoadingSpinnerModal isShowModal={showModal} modalChange={handleLoadShowModal} />)}
			<div className='card-box'>
				{!isDetailLoaded && !isPreviewPage && (
					<form name="createform" onSubmit={handleNextClick} className="create-form">
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="isActive" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblActive">Active</label>
							<div className={["col-sm-5"].join(" ")}>
								<div className="form-check form-switch" data-testid="channelSwitchContainer">
									<Input className="form-check-switch " type="checkbox" id="isActive" name="isActive"
										checked={isActive} onChange={() => { setIsActive(!isActive); setIsDirty(true) }} />
								</div>
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="title" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblTitle">Title</label>
							<div className={["col-sm-5"].join(" ")} data-testid="titleContainer">
								<DABTextBox type="text" isRequired={true} id="title" isHover={false} onChange={(event) => { handleInputChange(event) }} value={input.title} maxLength={100}/>
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="uniqueCode" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblUniqueCode">Unique Code</label>
							<div className={["col-sm-5"].join(" ")} data-testid="uniqueCodeContainer">
								<Input disabled className={["form-control"].join(" ")} id="uniqueCode" name="uniqueCode"
									value={input.uniqueCode} onChange={(event) => { handleInputChange(event) }} isHover={false} maxLength={20} />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")} >
							<label htmlFor="description" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblDescription">Description</label>
							<div className={["col-sm-5"].join(" ")} data-testid="descriptionContainer">
								<div className="content-required">
									<DABHtmlEditor content={content} onChange={handleChange} id="description" />
								</div>
							</div>
						</div>  
						<div className={["row mb-3"].join(" ")} >
							<label htmlFor="keywords" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblKeywords">Keywords</label>
							<div className={["col-sm-5"].join(" ")}>
								<div className="content-required" data-testid="keywordsContainer">
									<Input type="textarea" className={["form-control"].join(" ")} id="keywords" name="keywords"
										value={input.keywords} onChange={(event) => { handleInputChange(event) }} isHover={false} />
								</div>
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="languageCode" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblLanguageCode">Language</label>
							<div className={["col-sm-5"].join(" ")} data-testid="languageContainer">
								<DABDropDown id="languageCode" value={input.languageCode}
									onChange={(event) => { handleInputChange(event); handleLanguageChange(event); }}
									options={langList} isRequired={true} isHover={false} />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="authorUserId" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblDefaultEpisodeAuthor">Default Episode Author</label>
							<div className={["col-sm-5"].join(" ")} data-testid="defaultEpisodeAuthorContainer">
								<DABDropDown id="authorUserId" value={input.authorUserId}
									onChange={(event) => { handleInputChange(event) }} options={authorList} isHover={false} />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="iconFile" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblIconImage">Upload Icon Image</label>
							<div className={["col-sm-5"].join(" ")}>
								<FormGroup data-testid="iconImageContainer">
									<Input type="file" name="iconFile" id="imgIcon" required={selectedIconFileName===""}
										accept="image/png, image/jpeg, image/jpg"
										onChange={(e) => { handleFileChange(e, "icon") }} />
									<FormText color="muted">
										Selected File: {selectedIconFileName}<br />
										Icon size : 200 X 200, Max file size 5mb
									</FormText>									
								</FormGroup>
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="bannerFile" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblBannerImage">Upload Banner Image</label>
							<div className={["col-sm-5"].join(" ")}>
								<FormGroup data-testid="bannerImageContainer">
									<Input type="file" name="bannerFile" id="imgBanner" required={selectedBannerFileName===""}
										accept="image/png, image/jpeg, image/jpg"										
										onChange={(e) => { handleFileChange(e, "banner") }} />
									<FormText color="muted">
										Selected File: {selectedBannerFileName}<br />
										Icon size : 200 X 200, Max file size 200mb
									</FormText>
								</FormGroup>
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="publishTime" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblPublishTime">Publish Time UTC</label>
							<div className={["col-sm-5"].join(" ")} data-testid="publishTimeContainer">
								<DABTextBox type="time" isRequired={true} id="publishTime" placeholder="Publish Time" isHover={false}
									onChange={(event) => { handleInputChange(event) }} value={input.publishTime} />
							</div>
						</div>
						<Row className="create-button">
							<Col lg="3" data-testid="cancelContainer">
								<Button className="" onClick={(e) => { handleBackClick(e); }}>CANCEL</Button>
							</Col>
							<Col lg="3" data-testid="nextButtonContainer">
								<Button type="submit" className="btn-submit-frm" value="Next" >NEXT</Button>
							</Col>
						</Row>
					</form>
				)}

				{isPreviewPage && !isDetailLoaded && (
					<form name="createform" onSubmit={handleSubmit} className="preview-form">
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="isActive" className={["col-sm-2 col-form-label"].join(" ")}>Active</label>
							<div className={["col-sm-5"].join(" ")}>
								<div className={["col-sm-12 col-form-label-value"].join(" ")} data-testid="prevChannelSwitch">
									{isActive ? "Yes" : "No"}
								</div>
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="title" className={["col-sm-2 col-form-label"].join(" ")}>Title</label>
							<div className={["col-sm-5"].join(" ")}>
								<div className={["col-sm-12 col-form-label-value"].join(" ")} data-testid="prevChannelTitle">
									{input.title}
								</div>
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="uniqueCode" className={["col-sm-2 col-form-label"].join(" ")}>Unique Code</label>
							<div className={["col-sm-5"].join(" ")}>
								<div className={["col-sm-12 col-form-label-value"].join(" ")} data-testid="prevChannelCode">
									{input.uniqueCode}
								</div>
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="description" className={["col-sm-2 col-form-label"].join(" ")}>Description</label>
							<div className={["col-sm-5"].join(" ")}>
								<div className={["col-sm-12 col-form-label-value"].join(" ")} data-testid="prevChannelDescription">
									{content !== null && (
										<span>{parse(content)}</span>
									)}
								</div>
							</div>
						</div>
						<div className={["row mb-3"].join(" ")} >
							<label htmlFor="keywords" className={["col-sm-2 col-form-label"].join(" ")}>Keywords</label>
							<div className={["col-sm-5"].join(" ")}>
								<div className={["col-sm-12 col-form-label-value"].join(" ")} data-testid="prevChannelKeywords">
									{content !== null && (
										<span>{ input.keywords }</span>
									)}
								</div>
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="languageName" className={["col-sm-2 col-form-label"].join(" ")}>Language</label>
							<div className={["col-sm-5"].join(" ")}>
								<div className={["col-sm-12 col-form-label-value"].join(" ")} data-testid="prevChannelLanguage">
									{Capitalize(languageName)}
								</div>
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="authorUserId" className={["col-sm-2 col-form-label"].join(" ")}>Default Episode Author</label>
							<div className={["col-sm-5"].join(" ")}>
								<div className={["col-sm-12 col-form-label-value"].join(" ")} data-testid="prevDefaultEpisodeAuthor">
									{authorList.find(x => x.value == input.authorUserId)?.text}
								</div>
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="iconFile" className={["col-sm-2 col-form-label"].join(" ")}>Upload Icon Image</label>
							<div className={["col-sm-5"].join(" ")}>
								<div className={["col-sm-5 col-form-label-value"].join(" ")} data-testid="prevIconImage">
									<CardImg onError={(e: any) => { e.target.src = NoImage }}
										className='card-box-img-icon' top width="100%"
										src={input.iconLocalPath}
										alt={input.title} />
								</div>
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="bannerFile" className={["col-sm-2 col-form-label"].join(" ")}>Upload Banner Image</label>
							<div className={["col-sm-5"].join(" ")}>
								<div className={["col-sm-5 col-form-label-value"].join(" ")} data-testid="prevBannerImage">
									<CardImg onError={(e: any) => { e.target.src = NoImage }}
										className='card-box-img-banner' top width="100%"
										src={input.bannerLocalPath}
										alt={input.title} />
								</div>
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="publishTime" className={["col-sm-2 col-form-label"].join(" ")}>Publish Time UTC</label>
							<div className={["col-sm-5"].join(" ")}>
								<div className={["col-sm-12 col-form-label-value"].join(" ")} data-testid="prevPublishTime">
									{input.publishTime}
								</div>
							</div>
						</div>
						<Row className="preview-button">
							<Col lg="3" data-testid="channelBack">
								<Button className="" onClick={(e) => { handleBackClick(e); }}>BACK</Button>
							</Col>
							<Col lg="3" data-testid="createButtonContainer">
								<Button className="btn-submit-frm" onClick={(e) => { handleNextClick(e); }}>CREATE</Button>
							</Col>
						</Row>
					</form>
				)}

				{isDetailLoaded && (
					<form name="createform" onSubmit={handleSubmit} className="update-form">
						<DABBackToList onClick={(e) => { handleBackClick(e); }} />
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="isActive" className={["col-sm-2 col-form-label"].join(" ")}>Active</label>
							<div className={["col-sm-5"].join(" ")}>
								<div className="form-check form-switch">
									<Input className="form-check-switch " type="checkbox" id="isActive"
										name="isActive" checked={isActive} onChange={(event) => { setIsActive(!isActive); }} />
								</div>
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="title" className={["col-sm-2 col-form-label"].join(" ")}>Title</label>
							<div className={["col-sm-5"].join(" ")} data-testid="titleContainer">
								<DABTextBox isRequired={true} type="text" id="title" onChange={(event) => { handleInputChange(event) }}
									value={input.title} isHover={true} maxLength={100} />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="uniqueCode" className={["col-sm-2 col-form-label"].join(" ")}>Unique Code</label>
							<div className={["col-sm-5"].join(" ")} data-testid="uniqueCodeContainer">
								<Input disabled className={["form-control"].join(" ")} id="uniqueCode" name="uniqueCode"
									value={input.uniqueCode} onChange={(event) => { handleInputChange(event) }} maxLength={20}/>
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="rssFeedUrl" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblFeedUrl">RSS Feed URL</label>
							<div className={["col-sm-5"].join(" ")} data-testid="rssFeedUrl">
								<DABTextBox type="text" id="rssFeedUrl" onChange={(event) => { handleInputChange(event) }}
									value={input.rssFeedUrl ? input.rssFeedUrl : ""} isHover={true} />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="hideChannelTitleFromRssFeed" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblHideChannelTitleFromRssFeed">Hide Channel Title from RSS Feed</label>
							<div className={["col-sm-5"].join(" ")}>
								<div className="form-check form-switch">
									<Input className="form-check-switch " type="checkbox" id="hideChannelTitleFromRssFeed"
										name="hideChannelTitleFromRssFeed" checked={hideChannelTitleFromRssFeed}
										onChange={() => { setHideChannelTitleFromRssFeed(!hideChannelTitleFromRssFeed); setIsDirty(true); }} />
								</div>
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label className={["col-sm-2 col-form-label"].join(" ")}>Description</label>
							<div className={["col-sm-5"].join(" ")} data-testid="descriptionContainer">
								<DABHtmlEditor content={content} onChange={handleChange} id="description" />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label className={["col-sm-2 col-form-label"].join(" ")}>Keywords</label>
							<div className={["col-sm-5"].join(" ")} data-testid="keywordsContainer">
								<DABTextBox type="textarea" id="keywords" onChange={(event) => { handleInputChange(event) }}
									value={input.keywords ? input.keywords : ""} isHover={true} />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="languageCode" className={["col-sm-2 col-form-label"].join(" ")}>Language</label>
							<div className={["col-sm-5"].join(" ")} data-testid="languageContainer">
								<DABDropDown id="languageCode" value={input.languageCode} isRequired={true}
									onChange={(event) => { handleInputChange(event); handleLanguageChange(event); }}
									options={langList} isHover={true} />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="authorUserId" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblDefaultEpisodeAuthor">Default Episode Author</label>
							<div className={["col-sm-5"].join(" ")} data-testid="defaultEpisodeAuthorContainer">
								<DABDropDown id="authorUserId" value={input.authorUserId}
									onChange={(event) => { handleInputChange(event) }} options={authorList} isHover={true} />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="publishTime" className={["col-sm-2 col-form-label"].join(" ")}>Publish Time UTC</label>
							<div className={["col-sm-5"].join(" ")} data-testid="publishTimeContainer">
								<DABTextBox type="time" isRequired={true} id="publishTime" placeholder="Publish Time"
									onChange={(event) => { handleInputChange(event) }} value={input.publishTime} isHover={true} />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="sortOrder" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblSortOrder">Sort Order</label>
							<div className={["col-sm-5"].join(" ")} data-testid="chnlSortOrder">
								<DABTextBox type="number" id="sortOrder" onChange={(event) => { handleInputChange(event) }} value={input.sortOrder} isHover={true} />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="rolloverMonth" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblRollOverMonth">Rollover Month</label>
							<div className={["col-sm-5"].join(" ")} data-testid="rollOverMonth">
								<DABTextBox type="number" id="rolloverMonth" onChange={(event) => { handleInputChange(event) }} value={input.rolloverMonth} isHover={true} />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="rolloverDay" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblRollOverDay">Rollover Day</label>
							<div className={["col-sm-5"].join(" ")} data-testid="rolloverDay">
								<DABTextBox type="number" id="rolloverDay" onChange={(event) => { handleInputChange(event) }} value={input.rolloverDay} isHover={true} />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="rolloverBuffer" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblRollOverBuffer">Rollover Buffer</label>
							<div className={["col-sm-5"].join(" ")} data-testid="rolloverBuffer">
								<DABTextBox type="number" id="rolloverBuffer" onChange={(event) => { handleInputChange(event) }} value={input.rolloverBuffer} isHover={true} />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")} >
							<label htmlFor="iconFile" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblIconImage">Upload Icon Image</label>
							<div className={["col-sm-5"].join(" ")} id="image-container">
								<CardImg className='card-box-img-icon' top width="100%"
									src={isEditIconChange ? input.iconLocalPath : input.iconImage}
									alt={input.title} onClick={() => { handleImageClick("icon") }}
									onError={(e: any) => { e.target.src = NoImage;}} />
								<input type="file" name="iconFile" id="imgIcon" ref={inputIconFile}
									accept="image/png, image/jpeg, image/jpg"
									onChange={(e) => { handleFileChange(e, "icon") }} style={{ display: 'black' }} />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")} >
							<label htmlFor="bannerFile" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblBannerImage">Upload Banner Image</label>
							<div className={["col-sm-5"].join(" ")} id="image-container">
								<CardImg className='card-box-img-banner' top width="100%"
									src={isEditBannerChange ? input.bannerLocalPath : input.bannerImageUrl}
									onError={(e: any) => { e.target.src = NoImage; }}
									alt={input.title} onClick={() => { handleImageClick("banner") }} />
								<input type="file" name="bannerFile" id="imgIcon" ref={inputBannerFile}
									accept="image/png, image/jpeg, image/jpg"
									onChange={(e) => { handleFileChange(e, "banner") }} style={{ display: 'black' }} />
							</div>
						</div>
						<Row className="update-button">
							<Col lg="8" className={["pull-right"].join(" ")} data-testid="updateButtonContainer">
								<DABButton id="Submit" className="btn-submit-frm" value="SAVE CHANGES"></DABButton>
							</Col>
						</Row>
					</form>
				)}
			</div>
		</div>
	);
};

const mapStateToProps = (state: any) => {
	const { channelData, languageData, userData } = state;
	return {
		channelData, languageData, userData
	};
};

export default connect(mapStateToProps)(ChannelDetail);